var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"heatmap",style:(`width: ${_vm.mapWidth}; height: ${_vm.mapHeight}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }